"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base_1 = require("../../../themes/base");
var SubNavigationWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  position: relative;\n  align-self: stretch;\n  background: ", ";\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  position: relative;\n  align-self: stretch;\n  background: ", ";\n  ", "\n"])), base_1.colors['grey-1'], function (_a) {
    var isNavigationOpen = _a.isNavigationOpen;
    return (isNavigationOpen ? '' : "border-bottom: 1px solid " + base_1.colors.border.light + ";");
});
exports.default = SubNavigationWrapper;
var templateObject_1;
//# sourceMappingURL=SubNavigationWrapper.js.map